import { render, staticRenderFns } from "./fbcheckbox.vue?vue&type=template&id=415384ee&"
import script from "./fbcheckbox.vue?vue&type=script&lang=js&"
export * from "./fbcheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports